// useGitConfigs - preloads the parameter values the package has maintained in Git.
//   GET /api/cicd/package-configs?spaceId&packageId&packageName&kennungen&artifactIds
//
// The wizard used to read its values from the tenants only, and the snapshot then rewrote the Git
// file with whatever was on screen - a QAS transport thus deleted the maintained PROD values. Git
// is the truth now, and it is read HERE, BEFORE the configuration view prefills its fields.
//
// The request names the source package and the kennungen, not finished target package ids: the
// suffix rule belongs in the backend, where the snapshot applies it too.

import { useCallback } from "react";
import { api } from "../../../utils/helpers";
import { useTransportV2, hasWerke, activeWerke } from "../context/TransportV2Context";

export function useGitConfigs() {
  const { state, dispatch } = useTransportV2();

  const laden = useCallback(async () => {
    // Nothing to load without a space or a package - but the state MUST still advance, or the
    // configuration view waits forever. An instance group without a space is selectable and yields
    // spaceId = null; the state then stayed "idle" and the footer reported everything as set while
    // the transport ran without any parameters.
    if (!state.spaceId || !state.pkgId) {
      dispatch({ type: "SET_GIT_CFG_STATE", payload: "leer" });
      return;
    }
    dispatch({ type: "SET_GIT_CFG_STATE", payload: "laedt" });
    const kennungen = hasWerke(state) ? activeWerke(state).map((w) => w.kennung).filter(Boolean) : [];
    const artefakte = Object.keys(state.sel || {});
    const q = new URLSearchParams({
      spaceId: state.spaceId,
      packageId: state.pkgId,
      packageName: state.pkgName || state.pkgId,
      kennungen: kennungen.join(","),
      artifactIds: artefakte.join(","),
    });
    try {
      const r = await api(`/api/cicd/package-configs?${q.toString()}`);
      dispatch({ type: "SET_GIT_CFG", payload: { werke: r?.werke || {}, unvollstaendig: !!r?.unvollstaendig } });
    } catch {
      // Not a hard stop: without a CI/CD project, or before the first snapshot, there is simply
      // nothing to load. The view then falls back to the tenants' current values.
      dispatch({ type: "SET_GIT_CFG_STATE", payload: "fehler" });
    }
    // All three final states ("da", "leer", "fehler") let the configuration view continue. Only
    // "idle" and "laedt" hold it, and both are transient.
  }, [state, dispatch]);

  return { laden };
}
